import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomDropdown from '@components//CustomDropdown';

import { setFilters } from '@store/common/action';
import { getCommonFilters } from '@store/reducers';

import { onGetFabricTypeList } from '@utils/MaterialsUtil';
import { capitalizeFirstLetter } from '@utils/Util';

const FabricSubCategory = ({
	type = 'FILTER',
	onSelectCallBack,
	isClearAll,
	onResetClearValue,
	isEditable,
	previousValue,
	title = 'Select...',
	isAddNew = false,
	onAddNew,
	isFabricTypeModify = false,
	onEditFabricType,
	fabricTypeList,
	setFabricTypeList
}) => {
	const [selectedItem, setSelectedItem] = useState('');
	const [isUpdated, setIsUpdated] = useState(true);
	const dispatch = useDispatch();
	const commonfilters = useSelector(getCommonFilters);

	let subCategories = fabricTypeList?.map((item) => {
		return {
			...item,
			id: item.id,
			value: `${capitalizeFirstLetter(`${item?.fabricType} - ${item?.groupName} - ${item.name}`)}`,
			fabricType: item.fabricType,
			name: item.name
		};
	});

	useEffect(() => {
		(async () => {
			const response = await onGetFabricTypeList(commonfilters);
			setFabricTypeList && setFabricTypeList(response);
		})();
	}, [commonfilters?.fabricTypes, isFabricTypeModify]);

	useEffect(() => {
		if (isEditable) {
			setSelectedItem(previousValue);
		}
	}, [previousValue]);

	useEffect(() => {
		if (isClearAll) {
			setSelectedItem('');
			setIsUpdated(false);
			setTimeout(() => {
				setIsUpdated(true);
			}, 0);
		}
	}, [isClearAll]);

	const onSelectFabric = (value) => {
		setSelectedItem(value.value);
		if (type === 'FILTER') {
			onResetClearValue(false);
			dispatch(setFilters({ ...commonfilters, constructions: value.name }));
		} else {
			onSelectCallBack(value);
		}
	};
	return (
		<div className="form-group size36 mb-0">
			{isUpdated && (
				<CustomDropdown
					title={title}
					isFocus={true}
					type="addItem"
					isAddNew={isAddNew}
					onItemClick={(value) => {
						if (value.isAddNew) {
							onAddNew(value.value);
						} else {
							onSelectFabric(value);
						}
					}}
					items={subCategories}
					selectedItem={selectedItem}
					isEditable={isEditable}
					onEdit={onEditFabricType}
				/>
			)}
		</div>
	);
};

export default FabricSubCategory;
